import React from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {fade} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    'display': 'flex',
    'alignItems': 'center',
    'padding': '10px 14px',
    'cursor': 'pointer',
    'fontSize': 13,
    'fontWeight': 700,
    '& .flag': {
      fontSize: 30,
    },
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.08),
    },
  },
}));

const LanguageItem = ({searchItem, onClick}) => {
  const {value} = searchItem;
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, 'pointer')} onClick={() => onClick(searchItem)}>
      {/* <CmtImage src={flags[locale]} /> */}
      <Box>{value}</Box>
    </Box>
  );
};

export default LanguageItem;
